import { render, staticRenderFns } from "./outAllowInfo.vue?vue&type=template&id=0937bb56&scoped=true&"
import script from "./outAllowInfo.vue?vue&type=script&lang=js&"
export * from "./outAllowInfo.vue?vue&type=script&lang=js&"
import style0 from "./outAllowInfo.vue?vue&type=style&index=0&id=0937bb56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0937bb56",
  null
  
)

export default component.exports